import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Range } from "./Range";
import { Rectangle } from "./Rectangle";
import { getDistance } from "../../Utils/NumberUtils";
export var Circle = /*#__PURE__*/function (_Range) {
  _inherits(Circle, _Range);

  var _super = _createSuper(Circle);

  function Circle(x, y, radius) {
    var _this;

    _classCallCheck(this, Circle);

    _this = _super.call(this, x, y);
    _this.radius = radius;
    return _this;
  }

  _createClass(Circle, [{
    key: "contains",
    value: function contains(point) {
      return getDistance(point, this.position) <= this.radius;
    }
  }, {
    key: "intersects",
    value: function intersects(range) {
      var pos1 = this.position,
          pos2 = range.position,
          distPos = {
        x: Math.abs(pos2.x - pos1.x),
        y: Math.abs(pos2.y - pos1.y)
      },
          r = this.radius;

      if (range instanceof Circle) {
        var rSum = r + range.radius,
            dist = Math.sqrt(Math.pow(distPos.x, 2) + Math.pow(distPos.y, 2));
        return rSum > dist;
      } else if (range instanceof Rectangle) {
        var _range$size = range.size,
            width = _range$size.width,
            height = _range$size.height,
            edges = Math.pow(distPos.x - width, 2) + Math.pow(distPos.y - height, 2);
        return edges <= Math.pow(r, 2) || distPos.x <= r + width && distPos.y <= r + height || distPos.x <= width || distPos.y <= height;
      }

      return false;
    }
  }]);

  return Circle;
}(Range);